import { ScrollReveal } from "@/components/base/ScrollAnimations";

export default function VisionSection() {
  return (
    <section className="bg-tie-grey-light py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Section Label */}
        <ScrollReveal>
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-6 md:mb-8">
            <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
              / Vision & Mission
            </span>
          </div>
        </ScrollReveal>

        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          {/* Left: Text Content */}
          <div>
            <ScrollReveal delay={100}>
              <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-snug">
                Strengthening Bangladesh's Textile & Apparel Competitiveness
                Through Practical Innovation
              </h2>
            </ScrollReveal>

            <ScrollReveal delay={200}>
              <div className="mt-6 md:mt-8 space-y-4 md:space-y-6">
                <div className="p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal/10 flex items-center justify-center shrink-0">
                      <i className="ri-eye-line text-tie-teal text-lg" />
                    </div>
                    <div>
                      <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-1">
                        Vision
                      </h3>
                      <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                        Strengthen Bangladesh's textile and apparel
                        competitiveness through practical, measurable, and
                        evidence-based innovation.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-5 md:p-6 rounded-xl bg-white border border-tie-grey-dark">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal/10 flex items-center justify-center shrink-0">
                      <i className="ri-compass-line text-tie-teal text-lg" />
                    </div>
                    <div>
                      <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-1">
                        Mission
                      </h3>
                      <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                        Connect the textile ecosystem to implement, measure, and
                        scale innovation across factories, institutions, and
                        markets.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="p-5 md:p-6 rounded-xl bg-tie-navy/5 border border-tie-grey-dark">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 rounded-lg bg-tie-teal/10 flex items-center justify-center shrink-0">
                      <i className="ri-lightbulb-flash-line text-tie-teal text-lg" />
                    </div>
                    <div>
                      <h3 className="text-base md:text-lg font-semibold text-tie-text-primary mb-1">
                        Why TIE Now
                      </h3>
                      <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                        Bangladesh's T&A sector is at an inflection point.
                        Competitive advantage now requires verified capability,
                        installed innovation systems, disciplined improvement,
                        and documented governance.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </ScrollReveal>

            <ScrollReveal delay={300}>
              <p className="mt-6 md:mt-8 text-sm md:text-base text-tie-text-muted italic leading-relaxed border-l-2 border-tie-teal pl-4">
                The question is not whether innovation will happen - it is
                whether innovation will be systematic, measurable, and
                sustainable.
              </p>
            </ScrollReveal>
          </div>

          {/* Right: Image */}
          <ScrollReveal delay={200} className="order-first lg:order-last">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20textile%20innovation%20laboratory%20with%20advanced%20machinery%20and%20fabric%20samples%2C%20warm%20lighting%2C%20professional%20corporate%20environment%2C%20engineers%20working%20with%20fabric%20testing%20equipment%2C%20clean%20industrial%20aesthetic%20with%20teal%20and%20navy%20accent%20lighting%2C%20premium%20quality%20photograph&width=800&height=900&seq=2&orientation=portrait"
                alt="Textile Innovation Lab"
                className="w-full h-[300px] md:h-[500px] lg:h-[600px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-tie-navy/40 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/90 backdrop-blur-sm">
                  <span className="w-2 h-2 rounded-full bg-tie-teal" />
                  <span className="text-xs font-medium text-tie-text-primary">
                    Evidence-Based Innovation Since 2018
                  </span>
                </div>
              </div>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}